<div class="row mt-2">

  <!-- SCENARII SELECTOR + BUILDING SELECTOR -->
  <div class="col-12 d-flex align-items-center flex-wrap">
    <app-scenarii-selector></app-scenarii-selector>
    <app-building-selector
      (buildingSelectionChanged)="onBuildingSelectionChanged($event)"
    ></app-building-selector>
  </div>

  <!-- ENERGY OR CARBON TRAJECTORY SELECTOR -->
  <div class="col-4 d-flex align-items-center mb-3">
    <app-energy-or-carbon-trajectory-filter></app-energy-or-carbon-trajectory-filter>
  </div>

  @if (displayEnergyChart$ | async) {
    <!-- ENERGY TRAJECTORY CHART -->
    <div class="col-8">
      <app-budget-or-ratio-filter [justifyContentRight]="true"></app-budget-or-ratio-filter>
    </div>
    <div class="col-12">
      <app-energy-trajectory-chart
        [perimeters]="[perimeter]"
        [isSideView]="true"
        [energyOrCarbon]="'energy'"
        [selectedBuildingIds]="selectedBuildingIds"
      ></app-energy-trajectory-chart>
    </div>
  } @else {
    <!-- CARBON TRAJECTORY CHART -->
    <div class="col-8">
      <app-budget-or-ratio-carbon-filter [justifyContentRight]="true"></app-budget-or-ratio-carbon-filter>
    </div>
    <div class="col-12">
      <app-carbon-trajectory-chart
        [perimeters]="[perimeter]"
        [isSideView]="true"
        [energyOrCarbon]="'carbon'"
        [selectedBuildingIds]="selectedBuildingIds"
      ></app-carbon-trajectory-chart>
    </div>
  }
</div>

@if ((isFidjiAct$ | async) === false) {
  <!-- TABS -->
  <nb-tabset (changeTab)="changeTab($event)">
    <!-- ACTIONS TABLE -->
    @if (showInitiatives) {
      <nb-tab tabId="1" [tabTitle]="'Actions spreadsheet' | translate" class="pt-3 pb-0 px-0">
        @if (scenario && selectedTabId === 1) {
          <app-initiatives-spreadsheet
            [inputFilters]="tablesFilter"
            [minimizedView]="true"
            [showScenarii]="true"
            [isFidjiAct]="false"
          ></app-initiatives-spreadsheet>
        }
      </nb-tab>
    }

    <!-- INVESTMENTS TABLE -->
    @if (showInvestments) {
      <nb-tab tabId="2" [tabTitle]="'Investments spreadsheet' | translate" class="inv pb-0 px-0">
        @if (scenario && selectedTabId === 2) {
          <app-investments-spreadsheet
            [investmentsListFilter]="tablesFilter"
          ></app-investments-spreadsheet>
        }
      </nb-tab>
    }

    <!-- PROJECTS TABLE -->
    @if (showProjects) {
      <nb-tab tabId="3" [tabTitle]="'Project table' | translate" class="pt-3 pb-0 px-0">
        @if (selectedTabId === 3) {
          <app-ag-grid-project></app-ag-grid-project>
        }
      </nb-tab>
    }

  </nb-tabset>
}
